// ** Custom Components
import Box from "../../components/Box"

import SectionExecutive from "./CorporateTeamSectionExecutive"
import SectionMarketing from "./CorporateTeamSectionMarketing"
import SectionCorporate from "./CorporateTeamSectionCorporate"
import SectionTech from "./CorporateTeamSectionTechnology"
import SectionFinance from "./CorporateTeamSectionFinance"

const CorporateTeamSectionStaffCards = () => {
  return (
    <Box className="flex flex-col gap-12 lg:gap-16">
      <SectionExecutive />
      <SectionMarketing />
      <SectionCorporate />
      <SectionTech />
      <SectionFinance />
    </Box>
  )
}

export default CorporateTeamSectionStaffCards
